/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomEditCard from '../../../../common/components/CustomEditCard/CustomEditCard';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import { jobInfoType } from '../../../../common/interfaces/myProfile/personalDetails/jobInfo';
import JobInfoUpdateModalController from '../../../../common/Modals/PersonalDetails/JobInfoModal/JobInfoUpdateModalController';
import { Box } from '@mui/system';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../../common/helper';

interface propsType {
  job: jobInfoType;
  hr_view?: boolean;
  trans?: any;
}
const JobInfoPresenter: React.FC<propsType> = ({ job, hr_view, trans }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div>
      <CustomEditCard
        card_title={trans('Job Information')}
        card_height="486px"
        onClick={() => {
          setOpenModal(true);
        }}
        showEditButton={hr_view}
      >
        <Box style={{ marginBottom: '24px' }} />
        <CardContentTile
          tile_key={trans('Staff Id')}
          tile_value={job?.staffId?.toString()}
        />
        <CardContentTile
          tile_key={trans('Hire Date')}
          tile_value={
            <DateField value={job?.hireDate} format={baseDateFormatting} />
          }
        />
        <CardContentTile
          tile_key={trans('Department')}
          tile_value={job?.departmentName}
        />
        <CardContentTile
          tile_key={trans('Employee Type')}
          tile_value={job?.employeeType}
        />
        <CardContentTile
          tile_key={trans('Contract Type')}
          tile_value={job?.contractType}
        />
        {job?.grade && (
          <CardContentTile tile_key={trans('Grade')} tile_value={job?.grade} />
        )}
        <CardContentTile
          tile_key={trans('Employee Category')}
          tile_value={job?.employeeCategory}
        />
        <CardContentTile
          tile_key={trans('Payroll Type')}
          tile_value={job?.payrollType}
        />
        <CardContentTile
          tile_key={trans('Extension Number')}
          tile_value={job?.extNo}
        />
        {job?.isDirectManager && (
          <CardContentTile
            tile_key={trans('IsDirectManager')}
            tile_value={job?.isDirectManager}
          />
        )}
        {job?.isDirectManagerStffId && (
          <CardContentTile
            tile_key={trans('IsDirectManagerStffId')}
            tile_value={job?.isDirectManagerStffId}
          />
        )}
      </CustomEditCard>

      {/* Job Info Modal */}

      {openModal && (
        <JobInfoUpdateModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          trans={trans}
        />
      )}
    </div>
  );
};

export default JobInfoPresenter;
